import { alpha, FormLabel, List, ListItem, styled } from '@mui/material';

export const TextList = styled('ul')(({ theme }) => ({
    marginLeft: `${theme.typography.generic.xxxxxLarge}`,
}));
export const ListItemText = styled('li')(({ theme }) => ({
    color: alpha(theme.palette.text.primary, 0.7),
    fontSize: theme.typography.customFontSize.small, // 14px
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '1.5rem', // 24px (171.429%)
}));

// ............. service form ...................
export const CustomFormLabel = styled(FormLabel)(({ theme }) => ({
    color: alpha(theme.palette.text.primary, 0.7),
    fontSize: theme.typography.customFontSize.small, // 14px
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: `${theme.typography.generic.xSmall}`,
}));

export const SeviceFormBox = styled('div')(({ theme }) => ({
    borderRadius: theme.typography.borderRadius.xSmall, // 8px
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: `${theme.typography.generic.medium} ${theme.typography.generic.xLarge}`,
    marginTop: `${theme.typography.generic.xxxxxLarge}`,
}));

// Modal form styles

export const CompanyListStyled = styled(List)(({ theme }) => ({
    gap: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.typography.generic.none,
}));

export const CompanyListItemStyled = styled(ListItem)(({ theme }) => ({
    justifyContent: 'space-between',
    marginLeft: 0,
    marginRight: 0,

    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.typography.borderRadius.xxSmall,

    padding: `${theme.typography.generic.xLarge} ${theme.typography.generic.xLarge}`,

    // '&:hover': {
    //     border: `1px solid ${theme.palette.primary.main}`,
    // },

    '& .MuiTypography-root.MuiFormControlLabel-label': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.customFontSize.large,
        fontWeight: theme.typography.fontWeightSemiBold,
    },
}));

export const CompanyListItemTagStyled = styled('span')(({ theme, statusColor }) => {
    return {
        padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.small}`,
        borderRadius: theme.typography.borderRadius.xSmall, // 8px
        color: statusColor,
        backgroundColor: alpha(statusColor || theme.palette.success.main, 0.08),
        fontSize: theme.typography.customFontSize.small,
        lineHeight: theme.typography.customFontSize.small,
        fontWeight: theme.typography.fontWeightSemiBold,
    };
});
